// Upload function for forms (using an unsigned upload preset)
export const uploadToCloudinary = async (file, folder = 'nhhs-projects') => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) {
    console.error('❌ Missing Cloudinary environment variables.');
    return {
      success: false,
      error:
        'Cloudinary is not configured properly. Please check REACT_APP_CLOUDINARY_CLOUD_NAME and REACT_APP_CLOUDINARY_UPLOAD_PRESET.',
    };
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', folder);

  console.log(`☁️ Uploading ${file.name} to Cloudinary (folder: ${folder})...`);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      {
        method: 'POST',
        body: formData,
      }
    );

    const data = await response.json();

    if (!response.ok) {
      console.error('❌ Cloudinary upload failed:', data);
      throw new Error(data.error?.message || 'Upload failed');
    }

    console.log('✅ Upload successful:', data.secure_url);

    return {
      success: true,
      url: data.secure_url,
      publicId: data.public_id,
      format: data.format,
      bytes: data.bytes,
    };
  } catch (error) {
    console.error('❌ Cloudinary upload error:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Validate file before upload
export const validateFile = (file) => {
  const maxSize = 5 * 1024 * 1024; // 5MB
  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'application/pdf',
  ];

  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error:
        'Please select a valid image (JPG, PNG, GIF, WebP) or PDF file.',
    };
  }

  if (file.size > maxSize) {
    return {
      valid: false,
      error: 'File size must be less than 5MB.',
    };
  }

  return { valid: true };
};
